module.exports = __webpack_public_path__ + "static/1-7229548627d4aabecfc5133733d44c74.jpg";